/**
 * Represents the current currency settings.
 */
class State {
    /**
     * Create new instance of the state.
     */
    constructor() {
        /** @type {null|String} */
        this.currency = null;
        /** @type {Number} */
        this.taxRate = 0;
    }
}

/** @ignore */
export default new State();



// WEBPACK FOOTER //
// ./src/plugins/easycurrency/state.js